import { useParams } from "react-router-dom";
import { useGetApiPBITokens, useGetApiPBITokensGetPBITokenRls } from "../../api/endpoints/index";
import PbiReportComponent from "./PbiReportComponent";
import { useTranslation } from "react-i18next";

export function PbiReportRls() {
  let params = useParams();
  const { t } = useTranslation();
  const {
    data: pbi,
    error,
    isLoading,
  } = useGetApiPBITokensGetPBITokenRls({
    workspaceId: params.wid ?? "",
    reportId: params.rid ?? "",
    orgId: params.oid ?? "",

  });

  if (isLoading) return <div>{t("pages.admin.pbi.loading")}</div>;
  if (error) return <div>{t("pages.admin.pbi.error")}</div>;
  return <PbiReportComponent pbi={pbi!}></PbiReportComponent>;
}
